import { View, Text, Pressable, Switch, Modal, StyleSheet } from 'react-native';
import { useAppStore } from '../store/appStore';

export default function NotifyModal() {
  const showNotifyModal = useAppStore((s) => s.showNotifyModal);
  const setShowNotifyModal = useAppStore((s) => s.setShowNotifyModal);
  const dontNotify = useAppStore((s) => s.dontNotify);
  const setDontNotify = useAppStore((s) => s.setDontNotify);

  return (
    <Modal
      visible={showNotifyModal}
      transparent
      animationType="fade"
      onRequestClose={() => setShowNotifyModal(false)}
    >
      <Pressable style={styles.overlay} onPress={() => setShowNotifyModal(false)}>
        <Pressable style={styles.dialog} onPress={() => {}}>
          <View style={styles.header}>
            <Text style={styles.title}>Assalamu'alaikum</Text>
            <Pressable onPress={() => setShowNotifyModal(false)} style={styles.closeBtn}>
              <Text style={styles.closeText}>×</Text>
            </Pressable>
          </View>
          <View style={styles.body}>
            <Text style={styles.heading}>
              Revolutionizing the qur'an reading experience on web & mobile devices.
            </Text>
            <Text style={styles.subheading}>We are currently offering -</Text>
            <View style={styles.bulletList}>
              <Text style={styles.bullet}>• multi-lingual translations</Text>
              <Text style={styles.bullet}>• accompanied hadith & commentaries</Text>
              <Text style={styles.bullet}>• highly customizable reading experience</Text>
              <Text style={styles.bullet}>• beautiful audio recitations</Text>
            </View>
            <Text style={styles.subheading}>All for FREE.</Text>
            <Text style={[styles.subheading, { marginTop: 16 }]}>
              Soon, we plan to introduce features that will allow you to create personal bookmarks,
              sync your preferences across devices, read tafsirs and enjoy more colored themes in-sha-Allah.
            </Text>

            <View style={styles.switchRow}>
              <Text style={styles.switchLabel}>Don't show this again</Text>
              <Switch
                value={dontNotify === 1}
                onValueChange={(val) => setDontNotify(val ? 1 : 0)}
                trackColor={{ false: '#ccc', true: '#1ABC9C' }}
                thumbColor={dontNotify === 1 ? '#009587' : '#f4f3f4'}
              />
            </View>
          </View>
        </Pressable>
      </Pressable>
    </Modal>
  );
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialog: {
    backgroundColor: '#fff',
    borderRadius: 4,
    maxWidth: 500,
    width: '90%' as any,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 15,
    borderBottomWidth: 1,
    borderBottomColor: '#d3d3d3',
  },
  title: {
    fontSize: 18,
    fontWeight: '700',
    color: '#333',
  },
  closeBtn: {
    padding: 8,
  },
  closeText: {
    fontSize: 24,
    color: '#000',
    opacity: 0.5,
  },
  body: {
    paddingHorizontal: 24,
    paddingVertical: 16,
  },
  heading: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    lineHeight: 24,
    marginBottom: 12,
  },
  subheading: {
    fontSize: 14,
    lineHeight: 21,
    color: '#333',
    marginBottom: 4,
  },
  bulletList: {
    marginVertical: 8,
    paddingLeft: 12,
  },
  bullet: {
    fontSize: 14,
    lineHeight: 24,
    color: '#333',
  },
  switchRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 20,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: '#eee',
  },
  switchLabel: {
    fontSize: 14,
    color: '#333',
  },
});
